import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'redux-orm';
import orm from 'shared_redux/reducers/models/orm';

import View from './view';
import * as Actions from './actions';

import * as RosterSelectors from 'shared_redux/selectors/view/roster';
import * as ProfileSelectors from 'shared_redux/selectors/view/profile';

// Custom selector to get the selected team ID based on the group ID from the roster state
const getSelectedTeamIdFromRoster = createSelector(
    orm,
    state => state.database,
    state => RosterSelectors.getSelectedGroupId(state),
    (session, groupId) => {
        if (!groupId) return null;
        
        const Groups = session.Groups;
        const group = Groups.withId(groupId);
        return group ? group.team_id : null;
    }
);

// Custom selector to get all non-default groups for the selected team
const getGroupsForSelectedTeam = createSelector(
    orm,
    state => state.database,
    getSelectedTeamIdFromRoster,
    (session, selectedTeamId) => {
        if (!selectedTeamId) return [];
        
        const Teams = session.Teams;
        const team = Teams.withId(selectedTeamId);
        return team ? 
            team.groups.filter(group => !group.is_default).toRefArray() : 
            [];
    }
);

const mapStateToProps = (state, props) => {
    return {
        numSelected: RosterSelectors.getNumAthletesSelected(state),
        groupId: RosterSelectors.getSelectedGroupId(state),
        selectedTeamId: getSelectedTeamIdFromRoster(state),
        teams: ProfileSelectors.getTeamsWithDefaultGroups(state),
        groups: getGroupsForSelectedTeam(state),
        defaultOrgGroupId: ProfileSelectors.getDefaultOrgGroupId(state),
        isUploading: RosterSelectors.getIsBatchUploading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateSelectedGroup: Actions.updateSelectedGroup,
        deleteSelectedAthletes: Actions.deleteSelectedAthletes,
        saveSelectedAthletesCategories: Actions.saveSelectedAthletesCategories,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;
